import React, { useState } from 'react';
import UserMgtList from '../components/UserMgtList';
import UserCreationForm from '../components/UserCreationForm';

const UserMgt = () => {
    const [activeTab, setActiveTab] = useState('list');
    const [editingUser, setEditingUser] = useState(null);

    const handleEdit = (user) => {
        setEditingUser(user);
        setActiveTab('create');
    };

    return (
        <div className="max-w-6xl mx-auto p-6 space-y-6">
            <div className="flex justify-between items-center bg-white p-4 rounded-xl shadow-sm border">
                <h2 className="text-2xl font-bold text-gray-800">System User Management</h2>
                <div className="flex bg-gray-100 p-1 rounded-lg">
                    <button 
                        onClick={() => { setActiveTab('list'); setEditingUser(null); }}
                        className={`px-4 py-2 rounded-md ${activeTab === 'list' ? 'bg-white shadow text-blue-600' : 'text-gray-500'}`}
                    >
                        User List
                    </button>
                    <button 
                        onClick={() => setActiveTab('create')}
                        className={`px-4 py-2 rounded-md ${activeTab === 'create' ? 'bg-white shadow text-blue-600' : 'text-gray-500'}`}
                    >
                        {editingUser ? 'Edit User' : 'Create User'}
                    </button>
                </div>
            </div>

            {activeTab === 'list' ? (
                <UserMgtList onEdit={handleEdit} />
            ) : (
                <UserCreationForm 
                    initialData={editingUser} 
                    onSuccess={() => setActiveTab('list')} 
                />
            )}
        </div>
    );
};
export default UserMgt;